"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.default = (0, react_1.createContext)({
    permissions: function () { return new Promise(function (resolve) { return resolve([]); }); },
});
//# sourceMappingURL=PermissionContext.js.map